
import './App.css';
import Main from './components/Main';
import React, { useEffect } from "react";
function App() {
  useEffect(() => {

    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);


    const disableKeys = (e) => {

      if (e.key === "F12") e.preventDefault();
      if (e.ctrlKey && e.shiftKey && ['I','J','C'].includes(e.key)) e.preventDefault();
      if (e.ctrlKey && e.key === 'u') e.preventDefault();


      if (e.metaKey && e.altKey && ['I','J','C'].includes(e.key)) e.preventDefault(); 
      if (e.metaKey && e.key === 'u') e.preventDefault(); 
    };
    document.addEventListener("keydown", disableKeys);


    const checkDevTools = setInterval(() => {
      const widthThreshold = window.outerWidth - window.innerWidth > 100;
      const heightThreshold = window.outerHeight - window.innerHeight > 100;
      const devtoolsOpen = widthThreshold || heightThreshold;

      if (devtoolsOpen) {
        document.body.style.display = 'none'; 
      } else {
        document.body.style.display = '';
      }
    }, 500);


    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeys);
      clearInterval(checkDevTools);
    };
  }, []);
  return (
    <div className="App">

<Main/>
  
    </div>
  );
}

export default App;
